module.exports = __webpack_public_path__ + "static/mention_05-344815b11309d5cc285fb3b45b9f4acb.png";